export const PartnerDeactivationReasonType = {
  LIMITED_TIME: 'limited_reason',
  REST_OF_DAY: 'rest_of_day',
  UNKNOWN: 'unknown',
  CBPI: 'cbpi',
  CBPR: 'cbpr',
};
